'use strict';
import React from 'react';
import * as T from 'prop-types';
import moment from 'moment';


export function TaskDateView(props) {
  const date = props.date ? moment(props.date) : null;
  const dateMsg = date ? date.format('ll') : props.placeholder;
  const useTime = date && props.useTime;
  const timeMsg = useTime ? date.format('LT') : '';

  return `${dateMsg}${useTime ? ` / ${timeMsg}` : ''}`;
}

TaskDateView.propTypes = {
  className: T.string,
  date: T.oneOfType([
    T.number,
    T.instanceOf(Date),
  ]),
  useTime: T.bool,
  placeholder: T.string,
};

TaskDateView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskDate/TaskDateView.js